<template>
    <div>
        <!-- Type -->
        <noncustom-prop v-if="object.custom_type"
            :object='object'
            :property='{label: object.custom_type.label, column: "custom_type"}'>
        </noncustom-prop>

        <!-- Vessel Type  -->
        <noncustom-prop v-if="object.gen_fld1"
            :object='object'
            link='searchable-vessel_type-keyword'
            :property='{label: object.gen_fld1.label, column: "gen_fld1"}'>
        </noncustom-prop>

        <!-- Builder  -->
        <noncustom-prop v-if="object.gen_fld7"
            :object='object'
            link='searchable-actors-keyword'
            :property='{label: object.gen_fld7.label, column: "gen_fld7"}'>
        </noncustom-prop>

        <!-- Date Built  -->
        <noncustom-prop v-if="object.gen_fld4"
            :object='object'
            :property='{label: object.gen_fld4.label, column: "gen_fld4"}'>
        </noncustom-prop>
    </div>
</template>

<script>
    import ViewRelated from './../../mixins/viewRelated.js'
    import NoncustomVue from './parts/noncustom.vue'

    export default {
        props: ['object'],
        mixins: [ViewRelated],
        components: {
            'noncustom-prop': NoncustomVue,
        },
    };
</script>
